<template>
  <section class="services-block" :id="anchorId">
    <div class="container">
      <h2 v-if="data.content.section_title">{{ data.content.section_title }}</h2>
      <Divider />
      <div class="services-grid">
        <ServiceItem
          v-for="(service, index) in data.content.services"
          :key="index"
          :title="service.title"
          :description="service.description"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import ServiceItem from './Services/ServiceItem.vue';
import { useAnchorId } from '@/composables/useAnchorId';

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const anchorId = useAnchorId(toRef(props, 'data'));
</script>

<style lang="scss" scoped>
section {
  max-width: var(--main-width);
  margin-inline: var(--main-margin);
  overflow-x: hidden;
  border-radius: 4.25rem;
  background: var(--white);
  padding: 0;
  padding-bottom: 4rem;
  color: var(--dark);
}

.services-grid {
  margin-inline: var(--inline-margin);
  display: flex;
  flex-wrap: wrap;
  gap: 0rem;
}

.services-grid > * {
  flex: 1 1 300px;
  min-width: 0;
}

@media (--phone) {
  .services-grid > * {
    flex-basis: 100%;
  }
}
</style>
